import styled, { css } from 'styled-components'

import checkIcon from 'assets/images/check-icon-white.svg'

import { Color } from 'root-constants'

import { FlowButton } from '../../components/FlowButton'
import { FemiFlowColor } from '../../constants'
import { FlowDescription, FlowTitle } from '../../styles'

const planBodyStyles = css`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const StyledFlowDiscountOffer = {
  Content: styled.div`
    padding-bottom: 88px;
  `,
  Title: styled(FlowTitle)`
    margin-bottom: 16px;

    mark {
      position: relative;
      z-index: 0;
      display: inline-block;
      margin-top: 4px;
      padding: 0 19px;
      background: none;
      color: inherit;
      font-family: inherit;
      font-style: italic;
      font-weight: 400;

      &::before {
        content: '';
        position: absolute;
        z-index: -1;
        top: 3px;
        right: 0;
        bottom: -3px;
        left: 0;
        background-color: ${FemiFlowColor.PINK_LIGHT};
      }
    }
  `,
  Description: styled(FlowDescription)`
    margin-bottom: 24px;
  `,
  Plans: styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
  `,
  Tag: styled.p<{ isDark?: boolean }>`
    padding: 4px 12px;
    border-radius: 16px 16px 0 0;
    background-color: ${({ isDark }) =>
      isDark ? Color.BLACK : FemiFlowColor.GRAY_LIGHT};
    color: ${({ isDark }) => (isDark ? FemiFlowColor.PINK : Color.GRAY)};
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: center;
    text-transform: uppercase;
  `,
  CurrentPlanBody: styled.div`
    ${planBodyStyles};
    padding: 16px 15px;
    border: 1.5px solid ${FemiFlowColor.GRAY_LIGHT};
    border-top: none;
    border-radius: 0 0 16px 16px;
    background-color: ${Color.WHITE};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  `,
  NewPlanBody: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    border: 1.5px solid ${Color.BLACK};
    border-top: none;
    border-radius: 0 0 16px 16px;
    background-color: ${FemiFlowColor.GRAY_SURFACE};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  `,
  PlanRow: styled.div`
    ${planBodyStyles};
  `,
  Check: styled.span`
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${Color.BLACK};
    background-image: url(${checkIcon});
    background-position: center;
    background-repeat: no-repeat;
  `,
  PlanInfo: styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
  `,
  PlanName: styled.p`
    color: ${Color.BLACK};
    font-size: 17px;
    font-weight: 600;
    line-height: 26px;
    text-transform: uppercase;
  `,
  PlanPrice: styled.p`
    display: flex;
    gap: 4px;
    color: ${Color.GRAY};
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  `,
  OldPrice: styled.span`
    color: ${Color.GRAY};
    text-decoration: line-through;
    text-decoration-color: ${FemiFlowColor.STRIKE};
  `,
  Divider: styled.span`
    align-self: stretch;
    border-inline-start: 1px dashed ${Color.BLACK};
  `,
  PricePerDay: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 64px;
  `,
  DailyPrice: styled.p`
    color: ${Color.BLUE_DARK};
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
  `,
  PerDay: styled.p`
    color: ${Color.GRAY};
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  `,
  Separator: styled.div`
    height: 1px;
    background-color: ${FemiFlowColor.GRAY_LIGHT};
  `,
  TodayRow: styled.div`
    display: flex;
    justify-content: space-between;
    color: ${Color.BLACK};
    font-size: 17px;
    font-weight: 500;
    line-height: 26px;
  `,
  Disclaimer: styled.p`
    color: ${Color.GRAY};
    font-size: 10px;
    font-weight: 400;
    line-height: 15px;

    strong {
      font-weight: 600;
    }
  `,
  DiscountStart: styled.p`
    color: ${Color.GRAY};
    font-size: 10px;
    font-weight: 400;
    line-height: 15px;
    text-align: center;
  `,
  CancelButton: styled(FlowButton)``,
}
